import { motion } from "framer-motion";
import RankBadge from "./RankBadge";
import QuotaIndicator from "./QuotaIndicator";

export default function CargoCard({ cargo, index }) {
    const Icon = cargo.icon;
    return (
        <motion.article
            data-testid={`cargo-card-${cargo.slug}`}
            layout
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96 }}
            transition={{ duration: 0.3, delay: Math.min(index * 0.04, 0.3) }}
            className="glass-card glass-card-hover flex flex-col rounded-2xl p-5"
        >
            <div className="mb-4 flex items-start justify-between">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-violet-500/25 bg-violet-500/10 text-violet-300">
                    <Icon className="h-5 w-5" />
                </div>
                <div className="flex flex-col items-end gap-1.5">
                    <span className="font-code text-[10px] font-medium tracking-[0.2em] text-gray-600">
                        #{String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                        {cargo.categoria}
                    </span>
                </div>
            </div>
            <h3 className="font-display text-lg font-bold text-white">{cargo.nome}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-gray-400">
                {cargo.funcao}
            </p>
            <div className="mt-5 space-y-4 border-t border-white/[0.06] pt-4">
                <RankBadge rank={cargo.rank} />
                <QuotaIndicator quota={cargo.quota} slug={cargo.slug} />
            </div>
        </motion.article>
    );
}
